<!-- // 出入库 选择产品表格 -->
<template>
  <div>
    <el-table
      :data="tableData"
      row-key="productId"
      @cell-mouse-enter="handleCellMouseEnter"
      @cell-mouse-leave="handleCellMouseLeave"
      :row-style="changeColor"
    >
      <el-table-column v-if="showDelBtn" label="" width="50">
        <template #default="{ row, $index }">
          <el-button
            v-show="row.isHover"
            color="red"
            text
            :disabled="disabledDelAndAdd"
            @click="handleDeleteProduct(row, $index)"
          >
            <svg-icon iconClass="delete1" class="delete1" />
          </el-button>
          <span v-show="!row.isHover">{{ $index + 1 }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column v-if="showConnectPro" label="关联产品">
        <template #default="{ row, $index }">
          <el-button
            type="primary"
            text
            :disabled="!!row.productId"
            @click="handleConnectionProduct($index)"
            icon="Connection"
          ></el-button>
        </template>
      </el-table-column> -->
      <el-table-column prop="productName" label="产品名称">
        <template #default="{ row }">
          {{ row.productName }}
        </template>
      </el-table-column>
      <template v-if="isApplication">
        <el-table-column prop="productNum">
          <template #header>
            <svg-icon icon-class="required" style="color: red"></svg-icon
            >产品数量
          </template>
          <template #default="{ row }">
            <el-input
              type="number"
              v-integerOnly
              v-model="row.productNum"
              clearable
              :disabled="row.productId ? false : true"
              @blur="handleProductNumberBlur(row)"
            />
          </template>
        </el-table-column>
      </template>
      <el-table-column prop="productType" label="产品类型">
        <template #default="{ row }">
          {{ getDictNameByPCodeSCode("productType", row.productType) }}
        </template>
      </el-table-column>
      <el-table-column prop="operateTime" label="操作时间">
        <template #default="{ row }">
          {{ row.completeStatus == 1 ? row.operateTime : "" }}
        </template>
      </el-table-column>
      <el-table-column prop="supplierModel" label="供应商型号">
        <template #default="{ row }">
          {{ row.supplierModel }}
        </template>
      </el-table-column>
      <el-table-column prop="internalModel" label="内部型号">
        <template #default="{ row }">
          {{ getDictNameByPCodeSCode("internalModel", row.internalModel) }}
        </template>
      </el-table-column>
      <el-table-column prop="usageType" label="使用类型">
        <template #default="{ row }">
          {{ getDictNameByPCodeSCode("usageType", row.usageType) }}
        </template>
      </el-table-column>
      <el-table-column prop="inventoryNum" label="库存数量">
        <template #default="{ row }">
          {{
            row.inventoryNum
              ? row.inventoryNum
              : row.completeStatus == "0"
              ? 0
              : ""
          }}
        </template>
      </el-table-column>

      <template v-if="!isApplication">
        <el-table-column prop="productNum">
          <template #header>
            <svg-icon icon-class="required" style="color: red"></svg-icon
            >{{ inWarehouse ? "应入数量" : "应出数量" }}
          </template>
          <template #default="{ row }">
            <el-input
              type="number"
              v-integerOnly
              v-model="row.productNum"
              clearable
              :disabled="
                row.productId && changeProNum && row.canChange ? false : true
              "
              @blur="handleProductNumberBlur(row)"
            />
          </template>
        </el-table-column>
        <el-table-column prop="completeNum">
          <template #header>
            <svg-icon icon-class="required" style="color: red"></svg-icon>
            {{ inWarehouse ? "已入数量" : "已出数量" }}
          </template>
          <template #default="{ row }">
            <el-input
              :class="row.textErr ? 'redText' : ''"
              type="number"
              v-integerOnly
              v-model="row.completeNum"
              clearable
              @blur="computeNumber(event, row)"
              :disabled="
                row.productId &&
                row.usageType !== '1' &&
                row.completeStatus != 1
                  ? false
                  : true
              "
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="incompleteNum"
          :label="inWarehouse ? '未入数量' : '未出数量'"
        >
          <template #default="{ row }">
            <el-input
              type="number"
              v-integerOnly
              v-model="row.incompleteNum"
              :disabled="true"
            />
          </template>
        </el-table-column>
        <el-table-column v-if="showRecipient" prop="recipient">
          <template #header>
            <svg-icon icon-class="required" style="color: red"></svg-icon>收取人
          </template>
          <template #default="{ row }">
            <el-input
              type="text"
              v-model="row.recipient"
              :disabled="
                row.productId && row.completeStatus != 1 ? false : true
              "
            />
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template #default="{ row }">
            <el-button
              text
              plain
              type="primary"
              v-if="row.usageType === '1' && row.completeStatus == 1"
              @click="handleCheckEqpt(row)"
            >
              查看设备
            </el-button>
            <el-button
              text
              plain
              type="primary"
              v-else
              :disabled="
                row.productId &&
                row.usageType === '1' &&
                row.completeStatus != 1
                  ? false
                  : true
              "
              @click="handleAddEqpt(row)"
            >
              添加设备
            </el-button>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <el-row :gutter="8" class="mt5" v-if="showAddBtn">
      <el-col :span="1.5">
        <el-button
          type="primary"
          plain
          text
          icon="Plus"
          :disabled="disabledDelAndAdd"
          auto-insert-space
          @click="handleAdd"
          >添加</el-button
        >
      </el-col>
    </el-row>
    <ConnectionProduct
      ref="connectionProductRef"
      v-model="dialogOpen"
      @success="handleSuccess"
    ></ConnectionProduct>
    <AddEqpt
      v-model="addEqptDialogOpen"
      :data="addEqptData"
      :inWarehouse="inWarehouse"
      :warehouseId="warehouseId"
      :product_id="product_id"
      :applicationId="applicationId"
      :canEditNum="canEditNum"
      @success="handleAddEqptSuccess"
    />
    <el-dialog
      title="已录入设备号"
      v-model="dialogOpenCheck"
      width="600"
      append-to-body
      @close="closedCheck"
    >
      <el-scrollbar height="400px" class="mt10">
        <template v-for="(item, index) in eqptCheckList">
          <el-tag class="mr20 mt10" style="width: 150px"
            >{{ item.eqptCode }}
          </el-tag>
        </template>
      </el-scrollbar>
    </el-dialog>
  </div>
</template>

<script setup>
import { onMounted, ref, watch } from "vue";
import ConnectionProduct from "./ConnectionProduct.vue";
import AddEqpt from "./addEqpt";
import useCacheStore from "@/store/modules/cache";
import { errorMsg, infoMsg } from "@/utils/msgBox";
import { isNull } from "@/utils/fangerUtils";
import { selectInventoryNumByProductId } from "@/api/warehouse/statistics";

const cacheStore = useCacheStore();

const { getDictNameByPCodeSCode } = cacheStore;

const props = defineProps({
  data: {
    type: Array,
    default: () => [],
  },
  isApplication: {
    type: Boolean,
    default: false,
  },
  showDelBtn: {
    type: Boolean,
    default: true,
  },
  showAddBtn: {
    type: Boolean,
    default: true,
  },
  showConnectPro: {
    type: Boolean,
    default: true,
  },
  changeProNum: {
    type: Boolean,
    default: true,
  },
  inWarehouse: {
    type: Boolean,
    default: true,
  },
  showRecipient: {
    type: Boolean,
    default: false,
  },
  disabledDelAndAdd: {
    type: Boolean,
    default: false,
  },
  warehouseId: {
    type: String,
    default: "",
  },
  applicationId: {
    type: String,
    default: "",
  },
});

const connectionProductRef = ref(null);
const dialogOpen = ref(false);
const addEqptDialogOpen = ref(false);
const tableData = ref([]);

let curConnectionProductIndex = 0;
// 关联产品
const handleConnectionProduct = (index) => {
  curConnectionProductIndex = index;
  connectionProductRef.value.cleanSelect();
  dialogOpen.value = true;
};

// 单元格鼠标移入
const handleCellMouseEnter = (row) => {
  row.isHover = true;
};
// 单元格鼠标移除
const handleCellMouseLeave = (row) => {
  row.isHover = false;
};

const changeColor = (row) => {
  if (row.row.completeStatus == "1") {
    return {
      backgroundColor: "#e1e1e1",
    };
  }
};

const handleAdd = () => {
  // tableData.value.push({});
  if (props.warehouseId == "") {
    errorMsg("请先选择仓库");
    return;
  }
  curConnectionProductIndex = tableData.value.length;
  connectionProductRef.value.cleanSelect();
  dialogOpen.value = true;
};
// 删除产品
const handleDeleteProduct = (row, index) => {
  tableData.value.splice(index, 1);
};

// 关联成功
const handleSuccess = (data) => {
  tableData.value.push({});
  data.forEach((item, index) => {
    const itemCopy = {
      ...item,
      productNum: null,
      completeNum: 0,
      incompleteNum: null,
      eqptList: [],
      completeStatus: 0,
      canChange: true,
    };
    if (props.showRecipient) {
      itemCopy.recipient = null;
    }
    if (index == 0) {
      tableData.value[curConnectionProductIndex] = itemCopy;
    } else {
      tableData.value.push(itemCopy);
    }
  });
  getProductInventoryNum();
};

/**
 * 获取产品库存数量
 */
const getProductInventoryNum = () => {
  // 获取产品id列表
  const productIdList = [];
  const productIdDict = {};
  tableData.value.forEach((item) => {
    if (item.completeStatus === 0 || item.completeStatus === "0") {
      productIdList.push(item.productId);
      productIdDict[item.productId] = item;
    }
  });
  if (productIdList.length > 0) {
    selectInventoryNumByProductId(
      props.warehouseId,
      productIdList.join(",")
    ).then((res) => {
      res.data.forEach((item) => {
        if (item.productId in productIdDict) {
          productIdDict[item.productId].inventoryNum = item.productNum;
        }
      });
    });
  }
};

const canEditNum = ref(0);
let curAddEqptRowData = {};
const addEqptData = ref([]);
// 扫码添加设备
const product_id = ref();
const handleAddEqpt = (row) => {
  curAddEqptRowData = row;
  product_id.value = row.productId;
  if (row.productInventoryList) {
    addEqptData.value = row.productInventoryList;
  } else {
    addEqptData.value = [];
  }
  if (!row.canChange) {
    canEditNum.value = +row.oriIncompleteNumber;
  } else {
    canEditNum.value = +row.productNum;
  }
  addEqptDialogOpen.value = true;
};
const dialogOpenCheck = ref(false);
const eqptCheckList = ref([]);
// 查看设备
const handleCheckEqpt = (row) => {
  dialogOpenCheck.value = true;
  eqptCheckList.value = row.productInventoryList;
};

const closedCheck = () => {
  dialogOpenCheck.value = false;
  eqptCheckList.value = [];
};

// 产品数量失去焦点
const handleProductNumberBlur = (row) => {
  row.incompleteNum = Number(row.productNum) - Number(row.completeNum);
};

// 添加设备成功
const handleAddEqptSuccess = (data) => {
  curAddEqptRowData.completeNum = data.length;
  if (curAddEqptRowData.canChange) {
    curAddEqptRowData.incompleteNum =
      Number(curAddEqptRowData.productNum) - data.length;
  } else {
    curAddEqptRowData.incompleteNum =
      curAddEqptRowData.oriIncompleteNumber - data.length;
  }
  curAddEqptRowData.productInventoryList = data;
};

// 获取产品数据
const getProductData = (tip) => {
  const productData = [];
  if (tableData.value.length == 0) {
    errorMsg("请选择产品，最少选择一个产品");
    return null;
  }
  for (let i = 0; i < tableData.value.length; i++) {
    const item = tableData.value[i];
    if (!props.isApplication && item.incompleteNum < 0) {
      errorMsg(
        `产品${props.inWarehouse ? "已入数量" : "已出数量"}有误，请核对`
      );
      return null;
    }
    if (
      !props.isApplication &&
      item.completeStatus == "0" &&
      tip === undefined &&
      item.incompleteNum != 0
    ) {
      errorMsg(`存在${props.inWarehouse ? "未入产品" : "未出产品"}`);
      return null;
    }
    if (
      !props.isApplication &&
      props.showRecipient &&
      item.completeNum > 0 &&
      item.completeStatus == "0" &&
      (item.recipient === "" ||
        item.recipient === null ||
        item.recipient === undefined)
    ) {
      errorMsg("出库数量大于0时，收取人不能为空");
      return null;
    }
    delete item.isHover;
    delete item.textErr;
    if (isNull(item)) continue;
    if (!item.productNum || item.productNum === 0) {
      errorMsg("产品数量不能为0");
      return null;
    }
    if (
      !props.isApplication &&
      item.completeStatus == "0" &&
      (item.completeNum === null || item.completeNum === "")
    ) {
      errorMsg(`请填写${props.inWarehouse ? "已入数量" : "已出数量"}`);
      return null;
    }
    const productItm = {
      productId: item.productId,
      productNum: item.productNum ? Number(item.productNum) : 0,
      completeNum: item.completeNum ? Number(item.completeNum) : 0,
      incompleteNum: item.incompleteNum ? Number(item.incompleteNum) : 0,
      recipient: item.recipient ? item.recipient : "",
    };
    if (item.productInventoryList && item.productInventoryList.length > 0) {
      productItm.productInventoryList = item.productInventoryList;
    }
    if (item.completeStatus == "0") {
      productData.push(productItm);
    }
  }
  return productData;
};

// 清空产品数据
const clearProductData = () => {
  tableData.value = [];
};

onMounted(() => {
  watch(
    () => props.data,
    (newVal) => {
      tableData.value = newVal;
      getProductInventoryNum();
    }
  );
});
const computeNumber = (event, row) => {
  if (row.completeNum === "") {
    row.completeNum = 0;
  }
  if (row.completeStatus == "0" && !row.canChange) {
    if (+row.completeNum > +row.oriIncompleteNumber) {
      errorMsg("已入数量不能大于未入数量");
      row.textErr = true;
    } else {
      row.textErr = false;
    }
    row.incompleteNum = row.oriIncompleteNumber - row.completeNum;
  } else {
    if (!row.productNum) {
      infoMsg("请先填写产品数量");
      row.completeNum = "";
    } else {
      if (+row.completeNum > +row.productNum) {
        errorMsg("已入数量不能大于产品数量");
        row.textErr = true;
      } else {
        row.textErr = false;
      }
      row.incompleteNum = row.productNum - row.completeNum;
    }
  }
};

defineExpose({
  getProductData,
  clearProductData,
});
</script>

<style lang="scss" scoped>
.delete1 {
  color: red;
}
.redText {
  :deep(.el-input__wrapper) {
    box-shadow: 0 0 0 1px red inset !important;
  }
}
</style>
